module.exports = __webpack_public_path__ + "img/cjc_logo.d1a2688e.png";